import { http } from "../config/http"
import { http4014 } from "../config/http14"
import { http2022 } from "../config/http22"
import { http2028 } from "../config/http28"
import { decryptAesGcmB64 } from "../utils/crypto"

export const getAnswer = async (data: string, Client: string | null, botId: string, user_name: string | null, userHandler: string) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res: any = await http2022.post(`ask_query?client_env=vc&bot_name=vc&question=${data}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}`)
        // const res: any = await tempPAth.post(`ask_query?client_env=hof&bot_name=shopmate&question=${data}${user_name !== "" ? `&user_name=${user_name}` : ""}&conversation_id=${botId}`)
        // const res: any = await http.post(`ask_query?client_env=hof&bot_name=${Client}&question=${data}${localStorage.getItem("chatUserName") !== null && localStorage.getItem("chatUserName") !== "" ? `&user_name=${localStorage.getItem("chatUserName")}` : ""}&conversation_id=${botId}`)
        return { result: res?.data }

    } catch (error: any) {
        return { error: error.message }
    }
}


export const getBotConfigurations = async (id: string | null) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res: any = await http2022.get(`get_bot_configurations?bot_name=${id}&client_env=hof`)
        // const res: any = await http.get(`get_bot_configurations_new/?bot_name=${id}&client_env=hof`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const memoryClear = async () => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2028 : http4014
    try {
        const res: any = await http2022.post(`clear_memory`)
        return { result: res?.data }

    } catch (error: any) {
        return { error: error }
    }
}

export const getVerifyOTP = async (body: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const KEY_B64 = "wS/Fpl50yt7d1jHkz08RuEltjTxGJ6lt/7A0DhL3g0w="
        let depCustomerParse = ""
        if (localStorage.getItem("username")) {
         const depCustomer = await decryptAesGcmB64(JSON.parse(localStorage.getItem("username") as any), KEY_B64);
            depCustomerParse = JSON.parse(depCustomer).email;
          }
        const res = await http2022.post(`verify_otp?client_env=hof&user_name=${depCustomerParse}&otp=${body}`)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getHandler = async (val: string, oldValue: string | undefined) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res = await http2022.get(`generate_handler?client_env=hof&handler_name=${val}&old_handler_name=${oldValue}`)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

type user_story_bundling_type = {
    client_env: string | null,
    user_name?: string,
    handler_name: string,
    product_id: string,
    conversation_id: string,
}

export const user_story_bundling_api = async (body: user_story_bundling_type) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res = await http2022.post('user_story_bundling', body)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getRecommendationsStyleIdeas = async (body: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res: any = await http2022.post(`style_ideas?client_env=hof&product_id=${body.product_id}${body.user_name !== "" ? `&user_name=${body.user_name}` : ""}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const bundlingSuggestion = async (body: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res: any = await http2022.post(`bot_brought_recommendation?client_env=hof&product_id=${body.product_id}${body.user_name !== "" ? `&user_name=${body.user_name}` : ""}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}



export const botProductPageChat = async (body: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res: any = await http2022.post(`product_page_chat`, body)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const login = async (username: any, password: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res = await http2022.post('login_and_introspect', {
            user_name: username,
            password: password,
            client_env: 'hof'
        })
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message };
    }
}

export const getVerifiedEmail = async (body: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res = await http2022.post(`email_verify?user_name=${body}&client_env=hof`)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}


export const getUserValidation = async (body: any) => {
    const tempPAth = window.location.origin === 'https://shopmatese.rysun.in/' ? http2022 : http
    try {
        const res = await http2022.post(`user_validation?client_env=hof&user_name=${body}`)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}